import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/main.scss'
import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';

ReactDOM.render(<App />, document.getElementById('root'));
